var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"scan"},[_c('div',{staticClass:"scanBanner",on:{"click":_vm.scanCode}},[_c('img',{staticClass:"scanBannerImg",attrs:{"src":require("../../static/home/saoma.png")}})]),_vm._v(" "),_c('taber')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5fd3d872","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/HomeIndex.vue
// module id = null
// module chunks = 